import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {Injectable} from '@angular/core';
import {ConsultationCategoryModel} from '../consultationCategory.model';
import {ConsultationCategorySummaryConverter} from './consultationCategorySummary.converter';
import {
    ExamenDefinitionSummaryConverter
} from "../../../../../../examen/definition/api/entity/converter/examenDefinitionSummary.converter";
import {PermissionsConverter} from "../../../../../../common/converter/permissions.converter";
import {
    TreatmentDefinitionSummaryConverter
} from "../../../../../treatment/treatment-definition/api/entity/converter/treatmentDefinitionSummary.converter";

@Injectable({ providedIn: 'root' })
export class ConsultationCategoryConverter extends HttpModelConverter<ConsultationCategoryModel> {

    constructor(private summaryConverter: ConsultationCategorySummaryConverter,
                private examDefinitionSummaryConverter: ExamenDefinitionSummaryConverter,
                private treatmentDefinitionSummaryConverter: TreatmentDefinitionSummaryConverter,
                private permissionsConverter: PermissionsConverter) {
        super();
    }
    protected createInstance(): ConsultationCategoryModel {
        return new ConsultationCategoryModel();
    }

    protected enrichObject(result: ConsultationCategoryModel, src: ConsultationCategoryModel) {
        result.summary = this.summaryConverter.convert(src.summary);
        result.examDefinitions = src.examDefinitions.map(value => {
            return {
                examDefinition: this.examDefinitionSummaryConverter.convert(value.examDefinition),
                permissions: this.permissionsConverter.convert(value.permissions),
                id: value.id,
                position: value.position,
                lunaSpeech: value.lunaSpeech,
                lunaInput: value.lunaInput
            };
        });
        result.treatmentDefinitions = src.treatmentDefinitions.map(value => {
            return {
                treatmentDefinition: this.treatmentDefinitionSummaryConverter.convert(value.treatmentDefinition),
                permissions: this.permissionsConverter.convert(value.permissions),
                id: value.id,
                position: value.position,
                lunaSpeech: value.lunaSpeech,
                lunaInput: value.lunaInput
            };
        });
    }
}
